import React, { memo } from "react";

type Props = {
	children: React.ReactNode;
};

export const QuestionItemsInnerWrapper = memo(({ children }: Props) => {
	return <div className="ml-4 flex flex-col gap-y-8">{children}</div>;
});

QuestionItemsInnerWrapper.displayName = "QuestionItemsInnerWrapper";
